import { Phone, MessageCircle } from "lucide-react";
import { useLang } from "@/context";
import { CONTACT, waLink } from "@/i18n";

export const StickyBar = () => {
    const { t } = useLang();
    return (
        <div data-testid="mobile-sticky-contact-bar" className="fixed bottom-0 inset-x-0 z-50 md:hidden grid grid-cols-2 shadow-[0_-6px_24px_rgba(42,5,5,0.25)]">
            <a
                data-testid="mobile-sticky-call-bar"
                href={`tel:${CONTACT.phone1}`}
                className="flex items-center justify-center gap-2 bg-[#8D1717] active:bg-[#6D1010] text-white py-4 font-bold text-sm"
            >
                <Phone className="w-5 h-5" />{t.sticky.call}
            </a>
            <a
                data-testid="mobile-sticky-whatsapp-bar"
                href={waLink()}
                target="_blank"
                rel="noreferrer"
                className="flex items-center justify-center gap-2 bg-[#22C55E] active:bg-[#16A34A] text-white py-4 font-bold text-sm"
            >
                <MessageCircle className="w-5 h-5" />{t.sticky.whatsapp}
            </a>
        </div>
    );
};
